// Risk level colors
export const RISK_COLORS = {
  LOW: "#52803c",    // Green
  MEDIUM: "#ffd53b", // Amber/Yellow
  HIGH: "#d54559",   // Red
  INSUFFICIENT_DATA: "#9e9e9e", // Grey
} as const;

// Common text colors
export const TEXT_COLORS = {
  PRIMARY: "rgba(0, 0, 0, 0.87)",
} as const;
